export default __webpack_public_path__ + "static/media/search.878b4bf2.svg";